import { useFlags } from 'launchdarkly-react-client-sdk';

export default function useMoiLoginEnabledFlag(): boolean {
  const flags = useFlags();

  const moiLoginEnabled =
    process.env.MOI_LOGIN_ENABLED !== undefined
      ? process.env.MOI_LOGIN_ENABLED === 'true'
      : !!flags.moiLoginEnabled;

  return moiLoginEnabled;
}
